import { createSlice } from "@reduxjs/toolkit";

interface IReferralOrgData {
  carrierName?: string;
  contactName?: string;
  creationDate?: string;
  dotNumber?: string;
  email?: string;
  id?: number|null;
  phoneNumber?: string;
  referredOrgId?: number|null;
  signedUpDate?: string|null;
  status?: string;
  referralToken?:string
}
const initstate = {
    referalOrgData: 0 as IReferralOrgData,
};

export const ReferralSlice = createSlice({
    name: "referralOrgData",
    initialState: initstate,
    reducers: {
      setReferralOrg: (state, action) => {     
        let obj:IReferralOrgData = action.payload;  
        state.referalOrgData = obj;
      },
    },
});

export const { setReferralOrg } = ReferralSlice.actions;

export default ReferralSlice.reducer;
